module.exports = __webpack_public_path__ + "static/media/heart-svgrepo-com (4).838edcf1.svg";